import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '../views/LandingPage.vue'
import AllServices from '../views/AllServices.vue'
import ServiceSearch from '../views/ServiceSearch.vue'
import NotFound from '../components/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: LandingPage
  },
  {
    path: '/services',
    name: 'services',
    component: AllServices
  },
  {
    path: '/service-search',
    name: 'Service search',
    component: ServiceSearch
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/TosView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach(() => {
  const heading = document.querySelector('h1, .clcnsw-heading')
  if (heading) {
    heading.setAttribute('tabindex', '-1')
    heading.focus()
  }
})

export default router
